import {
  keyCloakLogin,
  sendOtp,
  registerCan,
  emailCheck,
  checkCandOtp,
  resetPassword,
  checkAndSendOTP,
} from "../apiFunction";
import { mapActions, mapGetters } from "vuex";
import { clearAllCookiesExceptGuest, extractProfileData } from "../helpers";
import EventBus from "../eventBus";
import { debounce } from "lodash";
import {
  required,
  email,
  maxLength,
  minLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { trackSignupCompleted, trackSignupStarted } from "../posthogHelpers";
const qs = require("qs");

export default {
  data() {
    return {
      //new

      useEmail: false,
      loginPhone: {
        number: "",
      },
      loginPhoneInvalid: false,
      loginPhoneCountryCode: "+91",
      otpCode: "",
      useOtp: true,
      setPasswordMode: false,
      setPassword: "",
      confirmPassword: "",
      otpSent: false,
      showSetPasswordOtp: false,
      showSetPassword: false,
      isResetPasswordMode: false,
      isNewUserPasswordSetup: false,
      userExists: null,
      hasPassword: null,

      //new

      incomingMode: null,
      incomingUserType: null,
      overlayOpacity: 0.46,
      mode: "login", // 'login' | 'register' | 'otp' | 'forgot' | 'forgotOtp'
      userType: "candidate",
      // Login fields
      email: "",
      password: "",
      rePassword: "",
      reConfirmpassword: "",
      showPass: false,

      sliderIndex: 0,
      sliderTimer: null,
      sliderImages: [
        require("@/assets/imgs/newhomepage/modal-left-1.png"),
        require("@/assets/imgs/newhomepage/modal-left-2.png"),
        require("@/assets/imgs/newhomepage/modal-left-3.png"),
        require("@/assets/imgs/newhomepage/modal-left-4.png"),
      ],
      redirectUrl: null,
      savedRedirectUrl: null,
      hideBusiness: false,
      // OTP fields
      otpDigits: {
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
        num6: null,
      },
      // State
      verifyotp: false,
      show: false,
      invalidCredential: false,
      invalidText: "",
      successText: "",
      registered: false,
      timerOut: false,
      remainingTime: 0,
      timer: null,
      emailExists: false,
      isFocused: false,
      // Password validation flags (used by mixin)
      showPassword: false,
      match: false,
      validPassword: false,
      invalidPhone: false,
      passwordminlength: "",
      passwordupper: "",
      passwordlower: "",
      passwordspecial: "",
      passwordnumber: "",
      candExists: false,
      showPopup: false,
      isOpen: false,
      windowWidth: window.innerWidth,
      retryAfter: 0,
      otpExceeded: false,
      sendOtpError: "",
      registeredLogin: false,
    };
  },
  validations() {
    return {
      email: {
        required: requiredIf(function () {
          return this.useEmail || this.userType !== "candidate";
        }),
        email,
        alphaEmail: (value) => {
          if (value === null || value === "") return true;
          return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
        },
        maxLength: maxLength(64),
      },
      loginPhone: {
        number: {
          required: requiredIf(function () {
            return !this.useEmail && this.userType === "candidate";
          }),
        },
      },
      otpCode: {
        required,
        numeric,
        minLength: minLength(6),
      },
      password: {
        required,
        maxLength: maxLength(55),
      },
      confirmPassword: {
        required,
        maxLength: maxLength(55),
      },
      setPassword: {
        required,
        maxLength: maxLength(55),
      },
      rePassword: {
        required,
        maxLength: maxLength(55),
      },
      reConfirmpassword: {
        required,
        maxLength: maxLength(55),
      },
      otpDigits: {
        num1: {
          required,
        },
        num2: {
          required,
        },
        num3: {
          required,
        },
        num4: {
          required,
        },
        num5: {
          required,
        },
        num6: {
          required,
        },
      },
    };
  },
  mounted() {
    if (this.isOpen && this.userType !== "admin") {
      this.startSlider();
    }
    this._resizeHandler = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this._resizeHandler);

    this._pageShowHandler = (event) => {
      if (event.persisted && this.isOpen) {
        this.show = false;
        EventBus.$emit("close-login-modal");
        this.clearAndReset(true);
      }
    };
    window.addEventListener("pageshow", this._pageShowHandler);

    // this._pageHideHandler = () => {
    //   if (this.isOpen) {
    //     this.show = false;
    //     EventBus.$emit("close-login-modal");
    //   }
    // };
    // window.addEventListener("pagehide", this._pageHideHandler);

    this._openLoginModalHandler = (payload) => {
      if (payload) {
        if (typeof payload === "string") {
          this.incomingMode = payload;
        } else {
          this.incomingMode = payload.mode || "login";
          this.redirectUrl = payload.redirectUrl || null;
          this.savedRedirectUrl = payload.redirectUrl || null;
          this.incomingUserType = payload.userType || "candidate";
          this.hideBusiness = payload.hideBusiness || false;
        }
      }
      this.isOpen = true;
    };

    this._closeLoginModalHandler = () => {
      this.isOpen = false;
    };

    EventBus.$on("open-login-modal", this._openLoginModalHandler);
    EventBus.$on("close-login-modal", this._closeLoginModalHandler);
  },
  beforeDestroy() {
    this.stopSlider();
    window.removeEventListener("resize", this._resizeHandler);
    window.removeEventListener("pageshow", this._pageShowHandler);
    // window.removeEventListener("pagehide", this._pageHideHandler);
    if (this._openLoginModalHandler) {
      EventBus.$off("open-login-modal", this._openLoginModalHandler);
    }
    if (this._closeLoginModalHandler) {
      EventBus.$off("close-login-modal", this._closeLoginModalHandler);
    }
  },
  watch: {
    show(val){
			if(!val) this.registeredLogin = false;
		},
    otpCode(newVal, oldVal) {
      if (newVal) {
        const sanitized = newVal.replace(/[^0-9]/g, "");
        if (sanitized !== newVal) {
          this.otpCode = sanitized;
        }
      }
      // Only touch when non-empty. Never $reset() here — it would undo an
      // explicit $touch() called by handleSubmit on empty-field submission.
      if (this.$v.otpCode && newVal && newVal.trim() !== "") {
        this.$v.otpCode.$touch();
      }
      if (newVal !== oldVal && newVal !== "") {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
    $route() {
      if (this.isOpen) {
        this.isOpen = false;
        EventBus.$emit("close-login-modal");
      }
    },
    isOpen(val) {
      if (!val) {
        EventBus.$emit("close-login-modal");
        this.stopSlider();
      } else {
        if (this.userType !== "admin") {
          this.startSlider();
        }
      }
    },
    userType(val) {
      this.mode = "login";
      this.clearData();
      this.mode = "login";
      if (val === "admin") {
        this.stopSlider();
        this.redirectUrl = null;
      } else {
        this.redirectUrl = this.savedRedirectUrl;
        if (this.isOpen) {
          this.startSlider();
        }
      }
    },
    mode(val) {
      this.clearData();
      if (val === "forgot") this.clearTimerData();
      else if (val === "register") {
        this.clearTimerData();
        this.initializeTel();
      } else {
        if (typeof this.destroyTel === "function") {
          this.destroyTel();
        }
      }
    },
    email(newVal, oldVal) {
      if (this.$v.email) {
        if (!newVal || newVal.trim() === "") {
          this.$v.email.$touch();
        } else {
          this.$v.email.$touch();
        }
      }
      if (newVal) {
        this.email = newVal.replace(/\s/, "").toLowerCase();
      }
      if (newVal !== oldVal) {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
    password(newVal, oldVal) {
      if (this.$v.password) {
        if (!newVal || newVal.trim() === "") {
          this.$v.password.$touch();
        }
      }
      if (newVal !== oldVal) {
        this.invalidText = "";
        this.invalidCredential = false;
      }
    },
    "otpDigits.num1"(val) {
      if (val && val.length != 1) {
        this.otpDigits.num2 = val[1];
        this.otpDigits.num3 = val[2];
        this.otpDigits.num4 = val[3];
        this.otpDigits.num5 = val[4];
        this.otpDigits.num6 = val[5];
        this.otpDigits.num1 = val[0];
        const prevInput =
          val.length == 2
            ? this.$refs["secondInput"]
            : val.length == 3
            ? this.$refs["thirdInput"]
            : val.length == 4
            ? this.$refs["fourthInput"]
            : val.length == 5
            ? this.$refs["fifthInput"]
            : this.$refs["sixthInput"];
        if (prevInput) {
          prevInput.focus();
        }
      }
    },
    "loginPhone.number"(val) {
      if (!val || val.trim() === "") {
        this.loginPhoneInvalid = false;
        if (this.$v.loginPhone && this.$v.loginPhone.number) {
          this.$v.loginPhone.number.$reset();
        }
        return;
      }
      if (this.$v.loginPhone && this.$v.loginPhone.number) {
        this.$v.loginPhone.number.$touch();
      }
      const value = val.replace(/\s+/g, "");
      const cleanCountry = this.loginPhoneCountryCode
        ? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
        : "91";
      if (cleanCountry === "91") {
        const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
        this.loginPhoneInvalid = !indianPhoneNumberRegex.test(value);
      }
    },
    loginPhoneCountryCode(newVal) {
      const cleanCountry = newVal
        ? newVal.toString().replace(/[\s+]/g, "")
        : "91";
      if (cleanCountry === "91") {
        const val = this.loginPhone.number || "";
        if (!val || val.trim() === "") {
          this.loginPhoneInvalid = false;
          return;
        }
        const cleanVal = val.replace(/\s+/g, "");
        this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
      }
    },

    rePassword(value) {
      if (this.reConfirmpassword) {
        if (value == this.reConfirmpassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    reConfirmpassword(value) {
      if (this.rePassword) {
        if (value == this.rePassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    setPassword(value) {
      // Only touch when non-empty. Never $reset() here — it would undo an
      // explicit $touch() called by handleSubmit on empty-field submission.
      if (this.$v.setPassword && value && value.trim() !== "") {
        this.$v.setPassword.$touch();
      }
      if (this.confirmPassword) {
        if (value == this.confirmPassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
    confirmPassword(value) {
      // Only touch when non-empty. Same reason as setPassword.
      if (this.$v.confirmPassword && value && value.trim() !== "") {
        this.$v.confirmPassword.$touch();
      }
      if (!value || value.trim() === "") {
        this.match = false;
      }
      if (this.setPassword) {
        if (value == this.setPassword) {
          this.match = false;
        } else {
          this.match = true;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      userData: "userVUEX/getUserData",
      accessToken: "userVUEX/getAccessToken",
      showAdmin: "userVUEX/getRedirectBack",
      mobileToken: "userVUEX/getMobileToken",
      resumeuuid: "userVUEX/getResumeuuid",
    }),
    isMobile() {
      return this.windowWidth <= 1028;
    },
    formattedTime() {
      let seconds = this.remainingTime;
      if (seconds < 60) {
        return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
      }

      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;

      let result = `${mins} ${mins === 1 ? "min" : "mins"}`;

      if (secs > 0) {
        result += ` ${secs} ${secs === 1 ? "sec" : "secs"}`;
      }

      return result;
    },
    loaderLabel() {
      // register / login view — OTP flow = "Loading", password flow = "Logging In"
      return this.useOtp && !this.registeredLogin ? "Loading" : "Logging In";
    },
    formatEmail() {
      if (!this.userData || !this.userData.email) {
        return "";
      }
      let str = this.userData.email.split("@")[0];
      if (str.length <= 5) {
        str = str.substring(0, 1) + "****" + str.substring(str.length - 1);
      } else {
        str = str.substring(0, 2) + "****" + str.substring(str.length - 2);
      }
      let value = str + "@" + this.userData.email.split("@")[1];
      return value;
    },
    passwordValidation() {
      let val = [];
      if (this.passwordminlength) {
        val.push(this.passwordminlength);
      }
      if (this.passwordupper) {
        val.push(this.passwordupper);
      }
      if (this.passwordlower) {
        val.push(this.passwordlower);
      }
      if (this.passwordspecial) {
        val.push(this.passwordspecial);
      }
      if (this.passwordnumber) {
        val.push(this.passwordnumber);
      }
      return val.join(", ");
    },
    checkpassowrdInvalid() {
      return (
        this.passwordminlength ||
        this.passwordupper ||
        this.passwordlower ||
        this.passwordspecial ||
        this.passwordnumber
      );
    },

    checkpassword() {
      if (this.regForm.password == this.regForm.confirmpassword) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions({
      userLogin: "userVUEX/login",
      saveAccess: "userVUEX/saveAccess",
    }),
    clearTimerData() {
      this.remainingTime = 0;
      this.retryAfter = 0;
      this.otpExceeded = false;
    },
    formatDuration(seconds) {
      if (seconds < 60) {
        return `${seconds} ${seconds === 1 ? "sec" : "secs"}`;
      }

      const mins = Math.floor(seconds / 60);
      return `${mins} ${mins === 1 ? "min" : "mins"}`;
    },
    handleLogoClick() {
      EventBus.$emit("close-login-modal");
      EventBus.$emit("logo-clicked");
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      setTimeout(() => {
        this.scrollToContainerOrWindow("home-container");
      }, 300);
    },
    scrollToContainerOrWindow(containerId) {
      const el = document.getElementById(containerId);
      const hasScrollableContainer = el && el.scrollHeight > el.clientHeight;

      if (hasScrollableContainer) {
        el.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      const mainContainer = document.querySelector(".main-new-container");
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    goToDemo() {
      if (this.$route.name === "RequestDemo") {
        this.scrollToContainerOrWindow("demo-container");
      } else {
        this.$router.push({ name: "RequestDemo" }).catch(() => {});
        setTimeout(() => {
          this.scrollToContainerOrWindow("demo-container");
        }, 100);
      }
      EventBus.$emit("close-login-modal");
    },
    // ─── Helpers ──────────────────────────────────────────────────────────────
    startSlider() {
      this.sliderTimer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopSlider() {
      if (this.sliderTimer) {
        clearInterval(this.sliderTimer);
      }
    },
    nextSlide() {
      this.sliderIndex = (this.sliderIndex + 1) % this.sliderImages.length;
    },
    setSlide(index) {
      this.sliderIndex = index;
      this.stopSlider();
      this.startSlider();
    },
    clearResumeClinic() {
      this.$store.commit("userVUEX/setresumeJobid", null);
      this.$store.commit("userVUEX/setresumeClinicuid", null);
    },
    clearAndReset(clearRedirect = true, clearSession = false) {
      if (!clearRedirect) {
        if (this.incomingMode) {
          this.mode = this.incomingMode;
          this.incomingMode = null;
        } else {
          this.mode = "login";
        }
        if (this.incomingUserType) {
          this.userType = this.incomingUserType;
          this.incomingUserType = null;
        } else {
          this.userType = "candidate";
        }
      }
      this.show = false;
      if (clearSession) {
        clearAllCookiesExceptGuest();
        this.$store.commit("userVUEX/setCandAccess", false);
        localStorage.clear();
      }
      this.clearData();
      if (clearRedirect) {
        this.redirectUrl = null;
        this.savedRedirectUrl = null;
        setTimeout(() => {
          this.hideBusiness = false;
        }, 300);
        try {
          this.$store.commit("userVUEX/setDownloadReport", false);
        } catch (e) {
          console.log(e);
        }
      }
    },
    // Terms/Privacy open in a new tab so the login popup stays open
    terms() {
      const { href } = this.$router.resolve({ name: "TermsAndConditions" });
      window.open(href, "_blank", "noopener");
    },
    goToPrivacyPolicy() {
      const { href } = this.$router.resolve({ name: "PrivacyPolicy" });
      window.open(href, "_blank", "noopener");
    },
    convertToUppercase() {
      this.regForm.referralCode = this.regForm.referralCode.toUpperCase();
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    checkForPanelAccess(details) {
      let val = details.filter((obj) => {
        if (
          obj.project == "recruitment" &&
          obj.userPermissions &&
          (obj.userPermissions.roles.includes("Panelist") ||
            obj.userPermissions.roles.includes("Recruiter + Panelist"))
        ) {
          return obj.userPermissions
            ? obj.userPermissions.isActive
            : obj.isActive;
        }
      });
      return val.length !== 0;
    },
    checkAccess(data, flag) {
      let val = data.details.filter((obj) => {
        if (obj.project == flag) {
          let active = obj.userPermissions
            ? obj.userPermissions.isActive
            : obj.isActive;
          if (active) return obj;
        }
      });
      return val.length !== 0;
    },
    checkAnyProjectAccess(data) {
      const access = data.details.filter((obj) => {
        let val = obj.userPermissions
          ? obj.userPermissions.isActive
          : obj.isActive;
        if (val) return obj;
      });
      return access.length !== 0;
    },
    setFailurePopup(message, login) {
      this.show = false;
      this.showPopup = true;
      this.invalidText = message;
      setTimeout(() => {
        this.showPopup = false;
        this.invalidText = "";
        this.candExists = false;
        if (login) {
          this.clearData();
          this.mode = "login";
          this.userType = "candidate";
        }
      }, 5000);
    },
    setNoAccess(message, notClear) {
      console.log(notClear, "*********888");
      this.show = false;
      this.invalidCredential = true;
      this.invalidText = message;
      if (!notClear) {
        setTimeout(() => {
          this.invalidText = "";
          this.invalidCredential = false;
        }, 5000);
      }
    },
    clearStore() {
      this.$store.commit("userVUEX/setToken", "");
      this.$store.commit("userVUEX/setRefreshToken", "");
      this.$store.commit("userVUEX/setPreference", {});
      this.$store.commit("userVUEX/setAssessment", {});
      this.$store.commit("userVUEX/setRecruitment", {});
      this.$store.commit("userVUEX/setCandidate", {});
      this.$store.commit("userVUEX/setTraining", {});
    },
    clearData() {
      this.invalidCredential = false;
      this.invalidText = "";
      this.invalidPhone = false;
      this.emailExists = false;
      this.countryCode = "+91";
      this.phoneNumber = "";
      this.registered = false;
      this.successText = "";
      this.email = "";
      this.useEmail = false;
      this.password = "";
      this.showPassword = false;
      this.passwordminlength = "";
      this.passwordupper = "";
      this.passwordlower = "";
      this.passwordspecial = "";
      this.passwordnumber = "";
      this.validPassword = false;
      this.match = false;
      this.regForm = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmpassword: "",
        countryCode: "+91",
        termsCondition: false,
        referralCode: "",
      };
      this.rePassword = "";
      this.reConfirmpassword = "";
      this.otpSent = false;
      if (this.loginPhone) {
        this.loginPhone.number = "";
      }
      this.loginPhoneCountryCode = "+91";
      this.loginPhoneInvalid = false;
      this.otpCode = "";
      this.useOtp = true;
      this.setPasswordMode = false;
      this.setPassword = "";
      this.confirmPassword = "";
      this.showSetPasswordOtp = false;
      this.isResetPasswordMode = false;
      this.isNewUserPasswordSetup = false;
      this.userExists = null;
      this.hasPassword = null;
      this.clearOtp();
      this.$v.$reset();
    },
    handleEdit() {
      this.setPasswordMode = false;
      this.showSetPasswordOtp = false;
      this.isResetPasswordMode = false;
      this.otpSent = false;
      this.otpCode = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.sendOtpError = "";
      this.clearOtp();
      this.clearTimer();
      this.timerOut = false;
      this.otpExceeded = false;
      this.$v.$reset();
    },

    /**
     * Called from the Edit button inside the Set Password / Reset Password info box.
     * Takes the user back to the very first identifier-entry screen (step 1)
     * while KEEPING the email / phone + country code they already entered.
     */
    handleIdentifierEdit() {
      // ── UI state ──────────────────────────────────────────────────────────
      this.setPasswordMode = false;
      this.isResetPasswordMode = false;
      this.showSetPasswordOtp = false;
      this.otpSent = false;
      this.useOtp = true;

      // ── Field values (all except identifier) ──────────────────────────────
      this.otpCode = "";
      this.password = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.match = false;
      this.validPassword = false;
      this.passwordminlength = "";
      this.passwordupper = "";
      this.passwordlower = "";
      this.passwordspecial = "";
      this.passwordnumber = "";

      // ── Server-side state ─────────────────────────────────────────────────
      this.userExists = null;
      this.hasPassword = null;
      this.invalidCredential = false;
      this.invalidText = "";

      // ── OTP digit boxes + timer ───────────────────────────────────────────
      this.clearOtp();
      this.clearTimer();
      this.timerOut = false;
      this.otpExceeded = false;
      this.sendOtpError = "";

      // ── Validation ────────────────────────────────────────────────────────
      this.$v.$reset();

      // NOTE: email, loginPhone.number, loginPhoneCountryCode, useEmail
      //       are intentionally left untouched so the identifier is pre-filled.
    },
    toggleLoginMode(isEmail) {
      this.useEmail = isEmail;
      this.email = "";
      this.loginPhone.number = "";
      this.loginPhoneInvalid = false;
      this.sendOtpError = "";
      this.invalidCredential = false;
      this.invalidText = "";
      this.$v.$reset();
    },
    validatePhoneNumber(val) {
      if (!val) {
        this.loginPhoneInvalid = false;
        return;
      }
      const dialCode = this.loginPhoneCountryCode
        ? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
        : "91";
      if (dialCode === "91") {
        const cleanVal = val.replace(/\s+/g, "");
        this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
      }
    },
    handlePhoneValidation(isInvalid) {
      const dialCode = this.loginPhoneCountryCode
        ? this.loginPhoneCountryCode.toString().replace(/[\s+]/g, "")
        : "91";
      if (dialCode === "91") {
        const cleanVal = (this.loginPhone.number || "").replace(/\s+/g, "");
        this.loginPhoneInvalid = !/^[6-9]\d{9}$/.test(cleanVal);
      } else {
        this.loginPhoneInvalid = isInvalid;
      }
    },

    // ─── OTP Timer ────────────────────────────────────────────────────────────

    pad(val) {
      return val < 10 ? "0" + val : val;
    },
    startTimer() {
      clearTimeout(this.timer);
      this.remainingTime = this.retryAfter;
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(this.timer);
          this.timerOut = false;
          this.otpExceeded = false;
          this.remainingTime = this.retryAfter;
        }
      }, 1000);
    },
    clearTimer() {
      clearInterval(this.timer);
    },

    // ─── OTP Input ────────────────────────────────────────────────────────────

    restrictToOneDigit(event) {
      if (["e", "E", "+", "-", "."].includes(event.key)) {
        event.preventDefault();
        return;
      }
      const currentValue = event.target.value;
      if (currentValue && currentValue.length >= 1) {
        event.preventDefault();
      }
    },
    moveToNextField(event, nextInputRef, prevInputRef) {
      if (event.target.value && event.target.value.length >= 1) {
        const nextInput = this.$refs[nextInputRef];
        if (this.handleBackspace(event)) {
          if (nextInput && event.keyCode !== 9) nextInput.focus();
        } else {
          const prevInput = this.$refs[prevInputRef];
          if (prevInput) {
            setTimeout(() => {
              prevInput.focus();
            }, 0);
          }
        }
      }
    },
    handleBackspace(event) {
      return !(event.keyCode === 8 || event.keyCode === 46);
    },
    clearOtp() {
      this.otpDigits.num1 = null;
      this.otpDigits.num2 = null;
      this.otpDigits.num3 = null;
      this.otpDigits.num4 = null;
      this.otpDigits.num5 = null;
      this.otpDigits.num6 = null;
      this.otpCode = "";
      const nextInput = this.$refs["firstInput"];
      if (nextInput) nextInput.focus();
      this.$v.otpDigits.$reset();
      if (this.$v.otpCode) {
        this.$v.otpCode.$reset();
      }
    },

    resetValidation(field) {
      if (this.$v[field]) {
        this.$v[field].$reset();
      }
    },
    usePassword() {
      this.useOtp = false;
      this.otpCode = "";
      this.clearOtp();
      this.resetValidation("password");
      this.invalidCredential = false;
      this.invalidText = "";
    },
    usePasswordOrSetup() {
      if (this.hasPassword === false) {
        // User exists but has no password — show set password flow with OTP
        this.isNewUserPasswordSetup = true;
        this.openPasswordSetup(true);
      } else {
        this.usePassword();
      }
    },
    useOtpLogin() {
      this.useOtp = true;
      this.password = "";
      this.otpCode = "";
      this.resetValidation("password");
      this.resetValidation("otpCode");
      this.invalidCredential = false;
      this.invalidText = "";
    },
    openPasswordSetup(isReset = false) {
      this.setPasswordMode = true;
      this.isResetPasswordMode = isReset;
      // Always show OTP field immediately
      this.showSetPasswordOtp = true;
      this.password = "";
      this.otpCode = "";
      this.setPassword = "";
      this.confirmPassword = "";
      this.match = false;
      this.passwordminlength = "";
      this.passwordupper = "";
      this.passwordlower = "";
      this.passwordspecial = "";
      this.passwordnumber = "";
      this.validPassword = false;
      this.clearOtp();
      this.resetValidation("password");
      this.resetValidation("setPassword");
      this.resetValidation("confirmPassword");
      this.invalidCredential = false;
      this.invalidText = "";
      // Reset userExists so a stale false from a prior new-user check
      // never causes register() to send register-account for an existing account.
      this.userExists = null;
      this.hasPassword = null;
      // For reset-password: call forgotPassword() synchronously — before Vue flushes
      // the DOM change from setPasswordMode=true. $nextTick would wait until after
      // the email field is unmounted, causing forgotPassword's validation guard to fail.
      if (isReset) {
        // Snapshot the login-account timer before forgotPassword() overwrites it.
        this._savedTimerOut = this.timerOut;
        this._savedRetryAfter = this.retryAfter;
        this._savedRemainingTime = this.remainingTime;
        // Always send reset-password OTP (covers both regular reset and new-user setup)
        this.forgotPassword();
      }
    },

    // ─── Password validation ──────────────────────────────────────────────────

    validatePassword(PasswordField = "password") {
      let pwd = "";
      if (PasswordField === "rePassword") {
        pwd = this.rePassword;
      } else if (PasswordField === "setPassword") {
        pwd = this.setPassword;
      } else {
        pwd = this.regForm.password;
      }
      this.passwordminlength = pwd.length < 6 ? "Min 6 char required" : "";
      this.passwordupper = !/^(.*[A-Z]){1,}.*$/.test(pwd) ? "1 Upper Case" : "";
      this.passwordlower = !/^(.*[a-z]){3}.*$/.test(pwd) ? "3 Lower Case" : "";
      this.passwordspecial = !/[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/.test(pwd)
        ? "1 special character"
        : "";
      this.passwordnumber = !/^(.*\d){1,}.*$/.test(pwd) ? "1 number" : "";
      this.validPassword =
        this.passwordminlength ||
        this.passwordupper ||
        this.passwordlower ||
        this.passwordspecial ||
        this.passwordnumber
          ? true
          : false;
    },
    preventPaste(event) {
      event.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z .]+$/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetterandSpace(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },
    numbersOnly(evt) {
      if (evt.target.nodeName === "INPUT") {
        const charCode = evt.key;
        if ((charCode < "0" || charCode > "9") && charCode !== ".") {
          evt.preventDefault();
        } else {
          if (
            this.regForm.countryCode == "+91" &&
            this.regForm.phoneNumber?.length >= 11
          ) {
            evt.preventDefault();
          }
        }
      }
    },
    otpNumbersOnly(evt) {
      const charCode = evt.key;
      if (charCode < "0" || charCode > "9") {
        evt.preventDefault();
      }
    },
    async login() {
      if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
        this.$refs.candmail.blur();
      if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
        this.$refs.candpass.blur();
      if (
        this.$refs.candphone &&
        typeof this.$refs.candphone.blur === "function"
      )
        this.$refs.candphone.blur();
      // Capture OTP flow state BEFORE clearStore() resets otpSent
      const isOtpFlow = this.useOtp && this.otpSent;
      const capturedOtpCode = this.otpCode;

      this.invalidCredential = false;
      clearAllCookiesExceptGuest();
      this.clearStore();
      localStorage.clear();
      let flag = this.userType;

      if (this.useEmail || flag !== "candidate") {
        if (this.$v.email.$invalid) {
          this.$v.email.$touch();
        } else if (!isOtpFlow && this.hasPassword !== false && this.$v.password.$invalid) {
          this.$v.password.$touch();
        }
        if (
          !this.$v.email.$invalid &&
          (isOtpFlow || this.hasPassword === false || !this.$v.password.$invalid)
        ) {
          this.show = true;
          const creds = isOtpFlow || this.hasPassword === false
            ? { username: this.email, otp: capturedOtpCode }
            : { username: this.email, password: this.password };
          await this.loginToProjects(flag, creds);
        }
      } else {
        if (this.$v.loginPhone.number.$invalid) {
          this.$v.loginPhone.number.$touch();
          this.loginPhoneInvalid = true;
        } else if (!isOtpFlow && this.hasPassword !== false && this.$v.password.$invalid) {
          this.$v.password.$touch();
        }
        if (this.loginPhoneInvalid) {
          return;
        }
        if (
          !this.$v.loginPhone.number.$invalid &&
          !this.loginPhoneInvalid &&
          (isOtpFlow || this.hasPassword === false || !this.$v.password.$invalid)
        ) {
          const phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          this.show = true;
          const creds = isOtpFlow || this.hasPassword === false
            ? { username: phoneNumber, otp: capturedOtpCode }
            : { username: phoneNumber, password: this.password };
          await this.loginToProjects(flag, creds);
        }
      }
    },
    async loginToProjects(flag, creds) {
      try {
        let usernameVal = creds ? creds.username : this.email.trim();
        let userData = {
          grant_type: "password",
          client_id: "vue-test-app",
          username: usernameVal,
        };
        // Use otp or password depending on what was provided
        if (creds && creds.otp !== undefined) {
          userData.otp = creds.otp;
        } else {
          userData.password = creds ? creds.password : this.password.trim();
        }
        let userDetails = {
          keycloak: qs.stringify(userData),
          username: usernameVal,
        };
        const response = await this.userLogin(userDetails);
        const isMobileLogin = creds && /^[0-9]+$/.test(creds.username);
        await this.getProjectsData(flag, false, response.data.access_token, undefined, isMobileLogin);
      } catch (error) {
        this.show = false;
        if (error.response && error.response.status == 401) {
          const isOtpLogin = creds && creds.otp !== undefined;
          const attemptsLeft = error.response.data && error.response.data.attempts_left;
          const attemptsMsg = attemptsLeft !== undefined
            ? ` ${attemptsLeft} ${attemptsLeft === 1 ? "attempt" : "attempts"} left.`
            : ".";
          this.setNoAccess(
            isOtpLogin ? `Wrong OTP.${attemptsMsg}` : `Invalid credentials.${attemptsMsg}`,
            true,
          );
        } else if (error.response && error.response.status == 429) {
          this.setFailurePopup(
            `Too many failed login attempts. Try again in ${this.formatDuration(
              error.response.data.retry_after,
            )}.`,
          );
        } else if (error.response && error.response.status == 400) {
          this.setFailurePopup(
            error.response.data.error_description || "Login failed.",
          );
        } else {
          this.setFailurePopup("Login failed! Please try again.");
        }
      }
    },
    async getProjectsData(flag, login, accessToken, type, fallbackOnUserAccessFailure = false) {
      clearAllCookiesExceptGuest();
      let loginData = {};
      try {
        let response;
        try {
          response = await keyCloakLogin(accessToken);
        } catch (userAccessError) {
          // If user-access call fails and we're in a fallback-allowed flow
          // (e.g. mobile login/registration), proceed with synthetic candidate access.
          if (fallbackOnUserAccessFailure) {
            console.warn("user-access call failed, proceeding with fallback:", userAccessError);
            this.$store.commit("userVUEX/setProfileData", { username: "Guest User", image: "" });
            loginData = { showPreference: true, type: flag };
            let loginType = this.useEmail
              ? (this.userData?.email || this.email)
              : (this.userData?.phoneNumber || this.loginPhone?.number);
            const data = {
              details: [{ project: "candidate", isActive: true }],
              flag,
              loginData,
              redirectUrl: this.redirectUrl,
              useEmail: this.useEmail,
              loginType,
            };
            await this.saveAccess(data);
            return;
          }
          throw userAccessError;
        }
        let userDataToStore = { ...response.data };
        if (response.data.details && response.data.details.length > 0) {
          const { image, username } = extractProfileData(
            response.data.details,
            flag,
          );
          userDataToStore.image = image;
          userDataToStore.username = username;
        }
        this.$store.commit("userVUEX/setProfileData", userDataToStore);
        let projects = response.data.details.filter((obj) => {
          let val = obj.userPermissions
            ? obj.userPermissions.isActive
            : obj.isActive;
          if (val) return obj;
        });
        if (projects.length === 0) {
          this.setNoAccess("You don't have access.");
        } else if (
          projects.length == 1 &&
          projects[0].project == "candidate" &&
          flag != "candidate"
        ) {
          this.setNoAccess("You don't have access.");
        } else {
          loginData = {
            showPreference: true,
            type: flag,
          };
          if (type && type == "google") {
            loginData.logged_in = "google";
          }
          let loginType = this.useEmail
            ? (this.userData?.email || this.email)
            : (this.userData?.phoneNumber || this.loginPhone?.number);
          let data = {
            details: projects,
            flag,
            loginData,
            redirectUrl: this.redirectUrl,
            useEmail: this.useEmail,
            loginType,
          };
          if (this.isMobile && flag === "admin") {
            if (this.checkForPanelAccess(projects)) {
              data.flag = "recruitment";
              this.saveAccess(data);
            } else {
              this.setNoAccess("This feature is accessible only through web!");
            }
          } else if (flag == "candidate" && !this.checkAccess(data, flag)) {
            this.setNoAccess("You don't have access!");
          } else if (this.checkAccess(data, flag)) {
            await this.saveAccess(data);
          } else {
            data.flag = "admin";
            this.saveAccess(data);
          }
        }
      } catch (error) {
        this.show = false;
        console.error(error);
        if (this.mode === "otp") {
          this.setFailurePopup("Login failed", true);
          clearAllCookiesExceptGuest();
        } else {
          this.setNoAccess("Login failed! Please try again.");
          clearAllCookiesExceptGuest();
        }
      }
    },

    // ─── Registration ─────────────────────────────────────────────────────────

    /**
     * Step 1: Send OTP for registration.
     */
    async register(resend) {
      clearAllCookiesExceptGuest();
      this.clearStore();
      localStorage.clear();
      if (resend) {
        this.clearOtp();
      }
      if (!resend) {
        if (
          this.$refs.setPassField &&
          typeof this.$refs.setPassField.blur === "function"
        )
          this.$refs.setPassField.blur();
        if (
          this.$refs.confirmPassField &&
          typeof this.$refs.confirmPassField.blur === "function"
        )
          this.$refs.confirmPassField.blur();
        if (
          this.$refs.candmail &&
          typeof this.$refs.candmail.blur === "function"
        )
          this.$refs.candmail.blur();
        if (
          this.$refs.candphone &&
          typeof this.$refs.candphone.blur === "function"
        )
          this.$refs.candphone.blur();

        if (this.useEmail && this.$v.email.$invalid) {
          this.$v.email.$touch();
        } else if (!this.useEmail && this.$v.loginPhone.number.$invalid) {
          this.$v.loginPhone.number.$touch();
          this.loginPhoneInvalid = true;
        } else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
          this.$v.setPassword.$touch();
        } else if (
          this.setPasswordMode &&
          (this.$v.confirmPassword.$invalid || this.match)
        ) {
          this.$v.confirmPassword.$touch();
        }
      }
      const isIdentifierValid = this.useEmail
        ? !this.$v.email.$invalid
        : !this.$v.loginPhone.number.$invalid;
      if (
        (!resend &&
          isIdentifierValid &&
          !this.match &&
          !this.validPassword &&
          !this.loginPhoneInvalid) ||
        resend
      ) {
        this.show = true;
        if (!resend) {
          let userdata = {};
          if (this.useEmail) {
            if (this.email) userdata.email = this.email.trim();
          } else {
            if (this.loginPhoneCountryCode)
              userdata.countryCode = this.loginPhoneCountryCode.trim();
            if (this.loginPhone.number) {
              userdata.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
            }
          }
          if (this.password) userdata.password = this.password.trim();
          if (this.confirmPassword)
            userdata.confirmPassword = this.confirmPassword.trim();
          this.$store.commit("userVUEX/setUserData", userdata);
        }
        // Build the sendOtp payload (used for both first call and resend)
        let otpPayload = {};
        if (this.useEmail) {
          otpPayload = {
            email: !resend ? this.email.trim() : this.userData.email,
          };
        } else {
          if (!resend) {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            otpPayload = {
              countryCode: dialCode,
              phoneNumber: this.loginPhone.number
                ? this.loginPhone.number.replace(/\D/g, "")
                : "",
            };
          } else {
            otpPayload = {
              countryCode: this.userData.countryCode,
              phoneNumber: String(this.userData.phoneNumber).replace(/\D/g, ""),
            };
          }
        }
        try {
          // ── Step 1 (first call only): check user info via checkAndSendOTP ──
          if (!resend) {
            const checkPayload = this.useEmail
              ? { email: this.email.trim() }
              : {
                  countryCode: this.loginPhoneCountryCode.startsWith("+")
                    ? this.loginPhoneCountryCode
                    : "+" + this.loginPhoneCountryCode,
                  phoneNumber: String(this.loginPhone.number).replace(/\D/g, ""),
                };
            const checkRes = await checkAndSendOTP(checkPayload);
            const checkData = checkRes.data?.data || checkRes.data;
            this.userExists = checkData.exists;
            this.hasPassword = checkData.hasPassword;
            if(!this.userExists){
              let loginType = this.useEmail
                ? this.email.trim()
                : String(this.loginPhone.number).replace(/\D/g, "");
              trackSignupStarted(loginType, this.useEmail);
            }
          }

          // Set type based on whether user exists: existing = login, new = register.
          // Also treat setPasswordMode (new-user registration flow) as register-account
          // because openPasswordSetup() resets userExists to null, making === false fail on resend.
          const isNewUser = this.userExists === false || (this.setPasswordMode && !this.isResetPasswordMode);
          otpPayload.type = isNewUser ? "register-account" : "login-account";

          // ── Step 2: send OTP via sendOtp ──────────────────────────────────
          const otpRes = await sendOtp(otpPayload);

          if (otpRes.status == 200) {
            const resData = otpRes.data?.data || otpRes.data;
            const rawRetryAfter =
              resData.retryAfter ?? resData.cooldownSeconds ?? 0;
            // Use retryAfter from response only if ≥ 60; otherwise default to 60
            this.retryAfter = rawRetryAfter >= 60 ? rawRetryAfter : 60;
            this.sendOtpError = "";
            this.show = false;
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
            this.otpSent = true;
            if (!resend && this.userType !== "candidate") this.mode = "otp";
          } else if (otpRes.status == 429) {
            this.show = false;
            const cooldown =
              otpRes.data?.data?.cooldownSeconds ??
              otpRes.data?.data?.retryAfter ??
              60;
            this.retryAfter = cooldown >= 60 ? cooldown : 60;
            this.otpSent = true;
            if (!resend && this.userType !== "candidate") this.mode = "otp";
            this.otpExceeded = true;
            setTimeout(() => { this.sendOtpError = ""; }, 5000);
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
          } else {
            this.show = false;
            this.sendOtpError = "Failed to send OTP. Please try again.";
            setTimeout(() => { this.sendOtpError = ""; }, 5000);
          }
        } catch (error) {
          this.show = false;
          const status = error.response && error.response.status;
          const errData =
            error.response && error.response.data && error.response.data.data;
          // Only show short, user-readable Detail strings; anything longer is an internal error
          const rawDetail = errData && errData.Detail;
          const msg =
            rawDetail && rawDetail.length <= 120
              ? rawDetail
              : "Failed to send OTP. Please try again.";

          if (status == 429) {
            this.otpSent = true;
            const cooldown = errData?.cooldownSeconds ?? errData?.retryAfter ?? 60;
            this.retryAfter = cooldown >= 60 ? cooldown : 60;
            setTimeout(() => { this.sendOtpError = ""; }, 5000);
            if (!resend && this.userType !== "candidate") this.mode = "otp";
            this.otpExceeded = true;
            if (this.retryAfter) {
              this.timerOut = true;
              this.startTimer();
            }
          } else {
            if (status == 409) this.candExists = true;
            this.sendOtpError = msg;
            setTimeout(() => { this.sendOtpError = ""; }, 5000);
          }
        }
      }
    },

    /**
     * Step 2: Verify OTP and complete registration.
     */
    async registerCandidate() {
      this.verifyotp = true;
      this.$v.otpDigits.$touch();
      if (this.$refs.setPassField) this.$refs.setPassField.blur();
      if (this.$refs.confirmPassField) this.$refs.confirmPassField.blur();
      if (this.$refs.candmail) this.$refs.candmail.blur();
      if (this.$refs.candphone && typeof this.$refs.candphone.blur === "function") this.$refs.candphone.blur();
      if (this.$refs.candotp) this.$refs.candotp.blur();

      if (this.useEmail && this.$v.email.$invalid) {
        this.$v.email.$touch();
      } else if (!this.useEmail && this.$v.loginPhone.number.$invalid) {
        this.$v.loginPhone.number.$touch();
      } else if (this.$v.otpCode.$invalid) {
        this.$v.otpCode.$touch();
      } else if (this.setPasswordMode && this.$v.setPassword.$invalid) {
        this.$v.setPassword.$touch();
      } else if (
        this.setPasswordMode &&
        (this.$v.confirmPassword.$invalid || this.match)
      ) {
        this.$v.confirmPassword.$touch();
      }

      this.show = true;
      this.verifyotp = false;
      const otpVal = this.otpCode;
      let payload = {
        ...this.userData,
      };
      if (this.setPassword) payload.password = this.setPassword.trim();
      payload.otp = Number(otpVal);
      if (this.resumeuuid) payload.uuid = this.resumeuuid;
      try {
        const response = await registerCan(payload);
        if (response.status == 200) {
          if (this.resumeuuid) {
            this.$store.commit("userVUEX/setNewUseruuid", true);
          }
          clearInterval(this.timer);
          this.show = false;
          this.registered = true;
          this.successText = "Registered successfully";

          setTimeout(async () => {
            this.registered = false;
            this.successText = "";
            this.registeredLogin = true;
            this.show = true;

            try {
              // Determine username: email or phone number (without country code)
              let username = "";
              if (this.useEmail) {
                username = (this.userData.email || this.email || "").trim();
              } else {
                username = (this.userData.phoneNumber || this.loginPhone.number || "").replace(/\D/g, "");
              }

              // Use password if one was set during registration, otherwise use the OTP
              const registrationPassword = this.setPassword || (this.userData && this.userData.password) || "";
              const regCreds = registrationPassword
                ? { username, password: registrationPassword }
                : { username, otp: this.otpCode };

              await this.loginToProjects("candidate", regCreds);
              // Only clear state on successful login
              this.clearData();
              this.clearOtp();
              this.$store.commit("userVUEX/setUserData", {});
            } catch (err) {
              console.error("Auto-login failed:", err);
              this.show = false;
              this.setNoAccess("Login failed after registration. Please try logging in manually.");
            }
          }, 2000);
          let loginType = this.useEmail
            ? (this.userData?.email || this.email)
            : (this.userData?.phoneNumber || this.loginPhone?.number);
          trackSignupCompleted(loginType, this.useEmail);
        } else {
          this.show = false;
          this.setFailurePopup("Registration failed. Please try again.");
        }
      } catch (error) {
        this.show = false;
        const status = error.response && error.response.status;
        const msg =
          error.response && error.response.data && error.response.data.data
            ? error.response.data.data.Detail
            : null;
        if (status == 400 || status == 401) {
          this.setNoAccess(msg || "Wrong OTP");
        } else {
          this.setFailurePopup(msg || "Registration failed. Please try again.");
        }
      }
    },

    // ─── Forgot Password ──────────────────────────────────────────────────────

    /**
     * Send forgot-password OTP then switch to OTP mode.
     */
    async forgotPassword(val) {
      if (val === "resend") {
        this.clearOtp();
      }
      // Admin always uses email; candidates may use phone
      const useEmailForForgot = this.useEmail || this.userType !== "candidate";

      if (!val) {
        if (useEmailForForgot) {
          if (this.$refs.candmail) this.$refs.candmail.blur();
          this.$v.email.$touch();
          if (this.$v.email.$invalid) return;
        } else {
          if (this.$refs.candphone && typeof this.$refs.candphone.blur === "function") this.$refs.candphone.blur();
          this.$v.loginPhone.number.$touch();
          if (this.$v.loginPhone.number.$invalid || this.loginPhoneInvalid)
            return;
        }
      }

      // let fullPhone = "";
      // if (!useEmailForForgot) {
      //   const dialCode = this.loginPhoneCountryCode.startsWith("+")
      //     ? this.loginPhoneCountryCode
      //     : "+" + this.loginPhoneCountryCode;
      //   fullPhone = dialCode + this.loginPhone.number;
      // }

      this.show = true;
      try {
        if (!val) {
          let userdata = { type: "reset-password" };
          if (useEmailForForgot) {
            userdata.email = this.email.trim();
          } else {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            userdata.countryCode = dialCode;
            userdata.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          }
          this.$store.commit("userVUEX/setUserData", userdata);
        }
        let payload = { type: "reset-password" };
        if (!val) {
          if (useEmailForForgot) {
            payload.email = this.email.trim();
          } else {
            const dialCode = this.loginPhoneCountryCode.startsWith("+")
              ? this.loginPhoneCountryCode
              : "+" + this.loginPhoneCountryCode;
            payload.countryCode = dialCode;
            payload.phoneNumber = this.loginPhone.number.replace(/\D/g, "");
          }
        } 
        else if(val === 'resendotp'){
            payload.email = this.userData.email;
        }
          else {
          // resend: restore from userData (which was stored correctly on first call)
          if (this.userData.email) {
            payload.email = this.userData.email;
          } else {
            payload.countryCode = this.userData.countryCode;
            payload.phoneNumber = String(this.userData.phoneNumber).replace(/\D/g, "");
          }
        }
        const response = await sendOtp(payload);
        if (response.status == 200 || response.status == 429) {
          if (response.status == 429) this.otpExceeded = true;
          // Always clear any existing timer before applying the new retryAfter
          this.clearTimer();
          this.timerOut = false;
          this.retryAfter =
            response.status == 429
              ? response.data.data.cooldownSeconds
              : response.data.data.retryAfter;
          this.show = false;
          if (this.retryAfter) {
            this.timerOut = true;
            this.startTimer();
          }
          if (!val && !this.setPasswordMode) this.mode = "forgotOtp";
        } else {
          this.show = false;
          this.setNoAccess(
            this.useEmail
              ? "This email ID is not registered with Hire3x."
              : "This phone number is not registered with Hire3x.",
          );
        }
      } catch (error) {
        this.show = false;
        if (error.response && error.response.status == 429) {
          this.otpExceeded = true;
          // Always clear any existing timer before applying the new retryAfter
          this.clearTimer();
          this.timerOut = false;
          this.retryAfter = error.response.data.data.cooldownSeconds;
          if (this.retryAfter) {
            this.timerOut = true;
            this.startTimer();
          }
          if (!val && !this.setPasswordMode) {
            this.mode = "forgotOtp";
          }
        } else
          this.setNoAccess(
            this.useEmail
              ? "This email ID is not registered with Hire3x."
              : "This phone number is not registered with Hire3x.",
          );
      }
    },

    async resetPasswordOTP() {
      this.verifyotp = true;
      if (this.userType === "candidate") {
        if (this.$v.otpCode.$invalid) {
          this.$v.otpCode.$touch();
          return;
        }
        this.show = true;
        this.verifyotp = false;
        let otpVal = this.otpCode;
        let payload = this.userData;
        payload.otp = Number(otpVal);
        try {
          const response = await checkCandOtp(payload);
          if (response.status == 200) {
            this.$store.commit("userVUEX/setUserData", {});
            this.$store.commit("userVUEX/setUserData", payload);
            await this.resetPassword();
          } else if (response.status == 400) {
            this.setNoAccess("OTP didn't match");
            this.clearOtp();
          } else {
            this.setNoAccess("Something went wrong!");
            this.clearOtp();
          }
        } catch (error) {
          const msg =
            error.response && error.response.data && error.response.data.data
              ? error.response.data.data.Detail
              : "Something went wrong!";
          this.setNoAccess(msg);
          this.clearOtp();
        }
      } else {
        this.$v.otpDigits.$touch();
        if (
          !this.$v.otpDigits.num1.$invalid &&
          !this.$v.otpDigits.num2.$invalid &&
          !this.$v.otpDigits.num3.$invalid &&
          !this.$v.otpDigits.num4.$invalid &&
          !this.$v.otpDigits.num5.$invalid &&
          !this.$v.otpDigits.num6.$invalid
        ) {
          this.show = true;
          this.verifyotp = false;
          let otpVal = `${this.otpDigits.num1}${this.otpDigits.num2}${this.otpDigits.num3}${this.otpDigits.num4}${this.otpDigits.num5}${this.otpDigits.num6}`;
          let payload = this.userData;
          payload.otp = Number(otpVal);
          try {
            const response = await checkCandOtp(payload);
            if (response.status == 200) {
              this.$store.commit("userVUEX/setUserData", {});
              this.$store.commit("userVUEX/setUserData", payload);
              this.$nextTick(() => {
                this.show = false;
                this.mode = "reset";
              });
            } else if (response.status == 400) {
              this.setNoAccess("OTP didn't match");
              this.clearOtp();
            } else {
              this.setNoAccess("Something went wrong!");
              this.clearOtp();
            }
          } catch (error) {
            const msg =
              error.response && error.response.data && error.response.data.data
                ? error.response.data.data.Detail
                : "Something went wrong!";
            this.setNoAccess(msg);
            this.clearOtp();
          }
        }
      }
    },
     async resetPasswordAdmin() {
      this.$refs.pass.blur();
      this.$refs.passnew.blur();
      if (this.$v.rePassword.$invalid || this.validPassword) {
        this.$v.rePassword.$touch();
      } else if (this.$v.reConfirmpassword.$invalid || this.match) {
        this.$v.reConfirmpassword.$touch();
      }
      if (
        !this.$v.rePassword.$invalid &&
        !this.$v.reConfirmpassword.$invalid &&
        !this.match &&
        !this.validPassword
      ) {
        this.show = true;
        try {
          let payload = {
            email: this.userData.email,
            otp: this.userData.otp,
            password: this.rePassword.trim(),
          };
          const res = await resetPassword(payload);
          if (res.status == 200) {
            this.$store.commit("userVUEX/setUserData", {});
            this.show = false;
            this.registered = true;
            this.successText = "Password reset success";
            setTimeout(() => {
              this.registered = false;
              this.successText = "";
              this.clearData();
              this.mode = "login";
            }, 3000);
          } else {
            this.setFailurePopup("Password reset failed");
          }
        } catch (error) {
          this.setFailurePopup(error.response.data.data.Detail);
        }
      }
    },

    async resetPassword() {
      if (this.userType === "candidate") {
        if (this.$refs.setPassField) this.$refs.setPassField.blur();
        if (this.$refs.confirmPassField) this.$refs.confirmPassField.blur();
        this.rePassword = this.setPassword;
        this.reConfirmpassword = this.confirmPassword;
        this.validatePassword("rePassword");
      } else {
        if (this.$refs.pass) this.$refs.pass.blur();
        if (this.$refs.passnew) this.$refs.passnew.blur();
      }

      if (this.$v.rePassword.$invalid || this.validPassword) {
        this.$v.rePassword.$touch();
      }
      if (this.$v.reConfirmpassword.$invalid || this.match) {
        this.$v.reConfirmpassword.$touch();
      }

      // Passwords invalid — stop here regardless of phase
      if (
        this.$v.rePassword.$invalid ||
        this.$v.reConfirmpassword.$invalid ||
        this.match ||
        this.validPassword
      ) {
        return;
      }

      // Phase 1 (candidate reset): passwords valid but OTP not sent yet → send OTP now
      if (this.isResetPasswordMode && !this.showSetPasswordOtp) {
        await this.forgotPassword();
        if (this.setPasswordMode) {
          this.showSetPasswordOtp = true;
        }
        return;
      }

      if (!this.otpCode || String(this.otpCode).trim().length < 6) {
        this.$v.otpCode.$touch();
      }
      if (
        !this.$v.rePassword.$invalid &&
        !this.$v.reConfirmpassword.$invalid &&
        !this.match &&
        !this.validPassword &&
        this.otpCode && String(this.otpCode).trim().length >= 6
      ) {
        this.show = true;
        try {
          let payload = {
            otp: Number(this.otpCode),
            password: this.rePassword.trim(),
          };
          if (this.userData.email) {
            payload.email = this.userData.email;
          } else {
            payload.countryCode = this.userData.countryCode;
            payload.phoneNumber = String(this.userData.phoneNumber).replace(/\D/g, "");
          }
          const res = await resetPassword(payload);
          if (res.status == 200) {
            this.$store.commit("userVUEX/setUserData", {});
            this.show = false;
            this.registered = true;
            this.successText = "Password set successfully";
            // Snapshot credentials before any state reset
            const _isNewUserPasswordSetup = this.isNewUserPasswordSetup;
            const _savedPassword = this.rePassword;
            const _savedEmail = this.email;
            const _savedPhone = this.loginPhone ? this.loginPhone.number : "";
            const _savedCountryCode = this.loginPhoneCountryCode;
            const _savedUseEmail = this.useEmail;
            setTimeout(async () => {
              this.registered = false;
              this.successText = "";
              if (this.userType === "candidate") {
                if (_isNewUserPasswordSetup) {
                  // Auto-login with the newly set password
                  this.show = true;
                  const flag = this.userType;
                  const username = _savedUseEmail
                    ? _savedEmail
                    : _savedPhone.replace(/\s+/g, "");
                  await this.loginToProjects(flag, {
                    username,
                    password: _savedPassword,
                  });
                  return;
                }

                // Normal reset-password flow: restore identifier and go back to login
                // Set mode first — the mode watcher calls clearData() so all
                // state (including otpSent) is cleanly reset before we restore.
                this.mode = "login";
                this.setPasswordMode = false;
                this.$nextTick(() => {
                  this.email = _savedEmail;
                  if (this.loginPhone) {
                    this.loginPhone.number = _savedPhone;
                  }
                  this.loginPhoneCountryCode = _savedCountryCode;
                  this.useEmail = _savedUseEmail;
                  this.useOtp = false;
                  this.otpSent = true;
                  this.userExists = true;
                  this.hasPassword = true;
                  this.isResetPasswordMode = false;
                  this.clearTimer();
                  this.timerOut = this._savedTimerOut || false;
                  this.retryAfter = this._savedRetryAfter || 0;
                  this.remainingTime = this._savedRemainingTime || 0;
                  this.otpExceeded = false;
                  if (this.timerOut && this.remainingTime > 0) {
                    this.startTimer();
                  }
                  this._savedTimerOut = null;
                  this._savedRetryAfter = 0;
                  this._savedRemainingTime = 0;
                  if (_savedUseEmail) {
                    this.$store.commit("userVUEX/setUserData", {
                      email: _savedEmail,
                    });
                  } else {
                    const dialCode = _savedCountryCode.startsWith("+")
                      ? _savedCountryCode
                      : "+" + _savedCountryCode;
                    this.$store.commit("userVUEX/setUserData", {
                      countryCode: dialCode,
                      phoneNumber: _savedPhone,
                    });
                  }
                });
              } else {
                this.mode = "login";
                this.setPasswordMode = false;
              }
            }, 3000);
          } else {
            this.setFailurePopup("Password reset failed");
          }
        } catch (error) {
          const detailMsg =
            error.response && error.response.data && error.response.data.data
              ? error.response.data.data.Detail
              : "Password reset failed";
          this.setFailurePopup(detailMsg);
        }
      }
    },

    // ─── Email existence check ────────────────────────────────────────────────
    debouncedCheckEmail: debounce(function () {
      this.checkEmailExistsLocal();
    }, 500),
    async checkEmailExistsLocal() {
      try {
        const res = await emailCheck(this.regForm.email);
        if (res.status == 200) {
          this.emailExists = res.data.data?.isCandidateValid;
        }
      } catch (error) {
        console.error(error);
      }
    },

    // ─── Initialize phone number input ────────────────────────────────────────────────
    initializeTel() {
      this.$nextTick(() => {
        const input = this.$refs.phoneInput?.$el;
        if (!input) return;
        // const input = this.$refs.phoneInput;
        if (input) {
          if (this.iti) {
            this.iti.destroy();
          }
          const iti = intlTelInput(input, {
            utilsScript:
              "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.3/js/utils.js",
            showSelectedDialCode: true,
            initialCountry: "IN",
            autoPlaceholder: "Phonee",
            formatOnDisplay: false,
          });
          this.iti = iti;

          const dropdown = input.parentElement.querySelector(
            ".iti__flag-container",
          );
          dropdown.addEventListener("click", function () {
            // Delay before accessing the search input field
            const dropdownContainer = document.querySelector(
              ".iti__dropdown-content",
            );
            const searchField =
              dropdownContainer.querySelector(".iti__search-input");
            if (searchField) {
              searchField.value = "";
              const inputEvent = new Event("input", {
                bubbles: true,
              });
              searchField.dispatchEvent(inputEvent);
            }
          });

          // Manually add an event listener to the input field for country change
          input.addEventListener("countrychange", () => {
            const code = iti.getSelectedCountryData().dialCode;
            const value = (this.regForm.phoneNumber || "").replace(/\s+/g, "");
            this.regForm.countryCode = "+" + code;
            if (this.regForm.countryCode != "+91" && this.regForm.phoneNumber) {
              this.invalidPhone = !iti.isValidNumber();
            } else if (this.regForm.countryCode == "+91") {
              const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
              if (indianPhoneNumberRegex.test(value)) {
                this.invalidPhone = false;
              } else {
                this.invalidPhone = true;
              }
            }
          });

          input.addEventListener("input", () => {
            if (this.regForm.countryCode != "+91") {
              this.invalidPhone = !iti.isValidNumber();
            }
          });
        }
      });
    },
    destroyTel() {
      if (this.iti) {
        this.iti.destroy();
        this.iti = null;
      }
    },
  },
};
